/* eslint-disable no-undef */
/* eslint-disable quote-props */
import React, { Component, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import Toast from '../_components/toast';
import { connect } from 'react-redux';
import * as globalActions from '../../actions/global';
import * as propertyActions from '@modules/appraisal/actions/property';
import * as propertyGlobalActions from '@modules/appraisal/actions/global';
import { fetchCaseSetting } from '@modules/appraisalAdmin/actions/letterCaseSetting';
import setupLogRocketReact from 'logrocket-react';
import selector from './selector';
import { IDLE_TIME } from '../../constants';
import '../../main.scss';
import moment from 'moment';
import useLogout from '@hooks/useLogout';

const PROIDGY_BI_DASHBOARD = 'Prodigy BI Dashboard';
const PROIDGY_APPRAISAL = 'Prodigy Appraisal';

class App extends Component {
  static propTypes = {
    asCodeDropdownsState: PropTypes.string,
    children: PropTypes.node.isRequired,
    currentAppraisalYear: PropTypes.string,
    isRecordingStart: PropTypes.bool,
    isSidebarVisible: PropTypes.bool,
    selectYear: PropTypes.func.isRequired,
    toggleSidebar: PropTypes.func.isRequired,
    userData: ImmutablePropTypes.map,
    fetchCurrentAppraisalYear: PropTypes.func.isRequired,
    fetchDropdowns: PropTypes.func.isRequired,
    fetchLetterCaseSetting: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    if (window.innerWidth < 768) {
      props.toggleSidebar();
    }
    this.splashLoader = document.getElementById('splash-screen');
  }

  async componentDidMount() {
    const { userData } = this.props;
    this.splashLoader.remove();
    this.initDropDowns(userData);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { isRecordingStart, userData } = this.props;
    if (!isRecordingStart && nextProps.isRecordingStart) {
      // when start
      this.startTheRootCauseRecord();
    }
    if (isRecordingStart && !nextProps.isRecordingStart) {
      // when stop
      this.stopTheRootCauseRecord();
    }
    if (!userData.get('id') && nextProps.userData.get('id')) {
      this.initDropDowns(nextProps.userData);
    }
  }

  async initDropDowns(userData) {
    const {
      fetchDropdowns,
      fetchCurrentAppraisalYear,
      fetchLetterCaseSetting,
      selectYear,
    } = this.props;
    if (userData.get('id')) {
      const modules = userData.get('modules').toJS();
      if (
        !modules.includes(PROIDGY_BI_DASHBOARD) &&
        !modules.includes(PROIDGY_APPRAISAL)
      ) {
        return;
      }
      fetchLetterCaseSetting();

      const res = await fetchCurrentAppraisalYear();
      if (res?.results?.year) {
        selectYear(res.results.year.toString());
        fetchDropdowns({
          fieldName: 'asCode',
          endpoint: '/appraisal/codes?type=Property&name=Abs-Subdv',
          year: res.results.year,
        });
        fetchDropdowns({
          fieldName: 'marketArea',
          endpoint: '/appraisal/codes?type=Property&name=Market Area',
          year: res.results.year,
        });
      }
    }
  }

  initFS() {
    const { userData } = this.props;
    if (!window.FS) {
      setTimeout(() => this.initFS(), 500);
      return;
    }
    FS.identify(userData.get('id'), {
      displayName: userData.get('name'),
      email: userData.get('email'),
    });
  }

  initRC() {
    const { userData } = this.props;
    if (!window.RC) {
      console.log('loading RC');
      setTimeout(() => this.initRC(), 500);
      return;
    }
    this.logger = new RC.Logger({
      autoStart: false,
      applicationId: '4daed5108f0a733b7ba766fd063445af4bf12ed4',
      recordSessionVideo: true,
      recordUserActions: true,
      logAjaxRequests: true,
      showFeedbackButton: {
        side: 'left',
      },
      user: {
        name: userData.get('name'),
        email: userData.get('email'),
      },
    });
  }

  initRL() {
    const { userData } = this.props;
    if (!window.LogRocket) {
      console.log('loading LogRocket');
      setTimeout(() => this.initRL(), 500);
      return;
    }
    setupLogRocketReact(LogRocket);
    LogRocket.identify(userData.get('id'), {
      name: userData.get('name'),
      email: userData.get('email'),
    });
  }

  initMapGeneratorModule() {
    if (!Microsoft || !Microsoft.Maps || !Microsoft.Maps.registerModule) {
      setTimeout(() => this.initMapGeneratorModule(), 500);
    }
    Microsoft.Maps.registerModule(
      'MapImageGeneratorModule',
      '/public/js/MapImageGeneratorModule.js',
    );
  }

  startFullStoryRecord() {
    FS.restart();
  }

  stopFullStoryRecord() {
    FS.shutdown();
  }

  startTheRootCauseRecord() {
    if (this.logger) {
      this.logger.start();
      this.logger.startVideoRecording();
      this.logger.showRecordingIcon();
    }
  }

  stopTheRootCauseRecord() {
    if (this.logger) {
      this.logger.stop();
      this.logger.stopVideoRecording();
      this.logger.hideRecordingIcon();
    }
  }

  render() {
    const { children, isSidebarVisible } = this.props;
    return (
      <WithInactiveLogout>
        <div className={!isSidebarVisible ? 'sidebar-hidden' : ''}>
          {children}
          <Toast />
        </div>
      </WithInactiveLogout>
    );
  }
}

export default connect(selector, (dispatch) => ({
  toggleSidebar: bindActionCreators(globalActions.toggleSidebar, dispatch),
  fetchDropdowns: bindActionCreators(
    propertyActions.fetchPropertyDropdowns,
    dispatch,
  ),
  fetchCurrentAppraisalYear: bindActionCreators(
    propertyGlobalActions.fetchCurrentAppraisalYear,
    dispatch,
  ),
  selectYear: bindActionCreators(propertyGlobalActions.selectYear, dispatch),
  fetchLetterCaseSetting: bindActionCreators(fetchCaseSetting, dispatch),
}))(App);

/**
 * Log out user from Auth0 if they are inactive for some time
 */
const WithInactiveLogout = ({ children }) => {
  const countRef = useRef(null);
  const { logout } = useLogout();

  // increments the countRef recursively until it reaches IDLE_TIME * 60, then logs out
  async function startIdleTimer() {
    const session = localStorage.getItem('session');
    const userData = JSON.parse(session);

    if (userData?.user?.expirationDt) {
      const expirationDt = moment(userData.user.expirationDt);
      const now = moment.utc(Date.now());

      const expireDate = new Date(
        expirationDt.format('YYYY-MM-DD HH:mm:ss'),
      ).getTime();
      const nowDate = new Date(now.format('YYYY-MM-DD HH:mm:ss')).getTime();
      const route = window.location.pathname.split('/').at(-1);

      if (expireDate < nowDate && route !== 'login') {
        logout();
      }
    }

    countRef.current++;
    if (countRef.current <= IDLE_TIME * 60) {
      setTimeout(() => startIdleTimer(), 1000);
    } else {
      logout();
    }
  }

  function resetIdleTimer() {
    countRef.current = 0;
  }

  useEffect(() => {
    // start idle timer when component mounts
    startIdleTimer();

    // set up event listeners. will reset timer to zero if mouse moves, etc.
    document.addEventListener('click', resetIdleTimer);
    document.addEventListener('mousemove', resetIdleTimer);
    document.addEventListener('keypress', resetIdleTimer);
    document.addEventListener('scroll', resetIdleTimer);
    document.addEventListener('touchstart', resetIdleTimer);

    // tear down event listeners when component unmounts
    return () => {
      document.removeEventListener('click', resetIdleTimer);
      document.removeEventListener('mousemove', resetIdleTimer);
      document.removeEventListener('keypress', resetIdleTimer);
      document.removeEventListener('scroll', resetIdleTimer);
      document.removeEventListener('touchstart', resetIdleTimer);
    };
  }, []);

  return children;
};
